<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-content>
          <b-container fluid>
            <hodimlar-form
              :modelvue="hodimlar"
              @com_time_change="com_time_change"
              :errors="errors"
            ></hodimlar-form>
            <md-card-content>
              <div class="tugmalarh">
                <div>
                  <b-button
                    @click="updateHodimlar()"
                    class="mr-2 calendar"
                    variant="success"
                  >
                    <b-icon icon="calendar2-plus"></b-icon> {{ $t("Saqlash") }}
                  </b-button>
                  <b-button
                    @click="cancel()"
                    variant="danger"
                    class="calendar1"
                  >
                    <b-icon icon="calendar2-x"></b-icon> {{ $t("Бекор қилиш") }}
                  </b-button>
                </div>
              </div>
            </md-card-content>
          </b-container>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import HodimlarForm from "./Form.vue";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  name: "HodimlarUpdate",
  components: {
    HodimlarForm
  },
  data() {
    return {
      hodimlar: {
        id: 0,
        password: "",
        role: "",
        room_id: 0,
        token: "",
        user_name: "",
        doctor_id: null,
        
        inspection_category_id: null,
        palata_percent: 0,
        pay_type: "Foiz",
        salary: 0,
        percent: 0,
        scot: 0,
        condition: "inaction",
        come_time_start: '',
        come_time: '',
        come_time_end: '',
        leave_time_start: '',
        leave_time: '',
        leave_time_end: '',
        to_count_time: false,
        hikvision_setting: `[
          {"name": "Якшанба", "come_time": "", "leave_time": "", "disabled": true},
          {"name": "Душанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Сайшанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Чоршанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Пайшанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Жума", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Шанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false}
        ]`
      },
      errors: null
    };
  },
  validations: {
    hodimlar: {
      password: {
        required,
        minLength: minLength(6)
      },
      role: {
        required,
        minLength: minLength(4)
      },
      room_id: {
        required
      },
      user_name: {
        required,
        minLength: minLength(4)
      },
      pay_type: {
        required
      }
    }
  },
  methods: {
    com_time_change(data, index){
      this.hodimlar.hikvision_setting = JSON.stringify(data)
    },
    updateHodimlar() {
      let self = this;
      this.$v.$touch();
      if (this.$v.$invalid == false) {
        axios({
          method: "patch",
          url: `/user/update/` + self.$route.params.id,
          data: self.hodimlar
        }).then(data => {
          if (data != undefined) {
            self.$router.push("/hodimlar");
          }
        });
      } else {
        self.errors = self.$v.hodimlar;
      }
    },

    getHodimlar() {
      let self = this;
      axios({
        method: "get",
        url: `/user/one/` + self.$route.params.id
      }).then(res => {
        if (res) {
          self.hodimlar = res.data.data;
          self.hodimlar.hikvision_setting = res.data.data.hikvision_setting ? res.data.data.hikvision_setting : 
          `[
            {"name": "Якшанба", "come_time": "", "leave_time": "", "disabled": true},
            {"name": "Душанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
            {"name": "Сайшанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
            {"name": "Чоршанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
            {"name": "Пайшанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
            {"name": "Жума", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
            {"name": "Шанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false}
          ]`
        }
      });
    },
    cancel() {
      this.hodimlar = {
        id: 0,
        password: "",
        role: "",
        room_id: null,
        token: "",
        user_name: "",
        doctor_id: null,
       
        inspection_category_id: null,
        palata_percent: 0,
        pay_type: null,
        salary: 0,
        scot: 0,
        come_time_start: '',
        come_time: '',
        come_time_end: '',
        leave_time_start: '',
        leave_time: '',
        leave_time_end: '',
        to_count_time: false,
        hikvision_setting: `[
          {"name": "Якшанба", "come_time": "", "leave_time": "", "disabled": true},
          {"name": "Душанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Сайшанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Чоршанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Пайшанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Жума", "come_time": "08:00", "leave_time": "17:00", "disabled": false},
          {"name": "Шанба", "come_time": "08:00", "leave_time": "17:00", "disabled": false}
        ]`
      };
    }
  },
  mounted() {
    this.getHodimlar();
  }
};
</script>
<style>
.tugmalarh {
  display: flex;
  justify-content: right;
  margin-right: 10px;
  margin-bottom: 10px;
}
.calendar {
  box-shadow: 5px 8px 10px rgba(25, 176, 48, 0.5);
}
.calendar1 {
  box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.5);
}
</style>
